import Character from './Character';

export default Character;


// WEBPACK FOOTER //
// /src/components/intro/pages/about/character/index.js